// @ts-ignore
import React from 'react';
import ButtonStyle from './Button.style';


export function AddToCartTextButton({onClick}) {
    return <span className="inline-flex rounded-md">
    <button
        onClick={onClick}
        type="button"
        className="inline-flex items-center px-4 py-2 text-sm leading-5 font-bold rounded-md text-scuttle-orange bg-white focus:outline-none transition ease-in-out duration-150">
     <svg className="w-6 h-6" fill="none" stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
  </svg>
        Add to cart
    </button>
  </span>;
}


type ButtonProps = {
    title: any;
    intlButtonId?: any;
    icon?: React.ReactNode;
    disabled?: boolean;
    onClick?: (e: any) => void;
    loader?: Object;
    loaderColor?: string;
    isLoading?: boolean;
    className?: string;
    fullwidth?: boolean;
    style?: any;
    type?: 'button' | 'submit' | 'reset';
    iconPosition?: 'left' | 'right';
    iconStyle?: any;
    size?: 'small' | 'medium';
    colors?: 'primary' | 'secondary';
    variant?:
        | 'textButton'
        | 'outlined'
        | 'outlinedDash'
        | 'outlinedFab'
        | 'extendedOutlinedFab'
        | 'fab'
        | 'extendedFab';
};

const Button: React.FC<ButtonProps> = ({
                                           type,
                                           size,
                                           title,
                                           intlButtonId,
                                           colors,
                                           variant,
                                           icon,
                                           disabled,
                                           iconPosition,
                                           iconStyle,
                                           onClick,
                                           loader,
                                           loaderColor,
                                           isLoading,
                                           className,
                                           fullwidth,
                                           style,
                                           ...props
                                       }) => {
    // Checking button loading state
    const buttonIcon =
        isLoading !== false ? (
            <>{loader ? loader : 'loading....'}</>
        ) : (
            icon && (
                <span className='btn-icon' style={iconStyle}>
          {icon}
        </span>
            )
        );

    // set icon position
    const position: string = iconPosition || 'right';

    return (
        <ButtonStyle
            type={type}
            className={`reusecore__button ${disabled ? 'disabled' : ''} ${
                isLoading ? 'isLoading' : ''
            } ${className ? className : ''}`.trim()}
            icon={icon}
            disabled={disabled}
            icon-position={position}
            onClick={onClick}
            colors={colors}
            variant={variant}
            fullwidth={fullwidth}
            style={style}
            size={size}
            {...props}
        >
            {position === 'left' && buttonIcon}
            {title && !isLoading && (
                <span className='btn-text'>
          {title}
        </span>
            )}
            {position === 'right' && buttonIcon}
        </ButtonStyle>
    );
};

Button.defaultProps = {
    disabled: false,
    isLoading: false,
    type: 'button',
};

export default Button;
